import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../doorstepServices/DoorstepServices.css"
import { IAppliedWorker, IRequirement } from "src/helper/interfaces";
import Cookies from "js-cookie";
import moment from "moment";
import Paginator from "src/components/layout/Paginator";
import LoadingGif from "src/components/layout/Loader";
import { stopLoading } from "src/store/loading/loadingSlice";
import iconPlaceholder from "../../../../assets/img/icons/landscape-placeholder-svgrepo-com.svg"
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg"
import currentAddress from "../../../../assets/img/icons/address-current.svg";
import { formatCategory, getSpecializations } from "src/utils/normalFuntions";
import StarRating from "src/components/layout/StarRating";
import { Link, useParams } from "react-router-dom";
import eye from "../../../../assets/img/icons/eye-solid.svg"

const getRequirementById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/requirement/${id}`, {
      headers: {
         "x-access-token": token
      }
   })
};

const getAppliedWorkers = async (
   token: string, id: string,
   pageNumber: number, pageSize: number
) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/requirement/applied-workers/${id}`, {
      headers: {
         "x-access-token": token
      },
      params: {
         page: pageNumber,
         pageSize,

      }
   })
}

export type sidePages = {
   appliedworkers: boolean,
}

const RequirementDetailsPage = () => {
   const { id } = useParams();

   const [show, setShow] = useState({
      edit: false,
      view: false
   });
   // const [selectedOption, setSelectedOption] = useState("job");
   const selectedOption = useAppSelector((state) => state?.requirementAnsSupport?.requirementType?.value);
   const Token = Cookies.get('token');
   const [selectedRequirement, setSelectedRequirement] = useState<IRequirement>();

   const loading = useAppSelector(state => state.loading.value);
   const [totalAppliedData, setTotalAppliedData] = useState({
      appliedCount: 0,
      viewedCount: 0
   });
   const [appliedWorkers, setAppliedWorkers] = useState<IAppliedWorker[]>([]);
   const [PaginatedData, setPaginatedData] = useState({
      pageNo: 1,
      pageSize: 20,
      totalPages: 0
   });
   const [clickedSidePage, setClickedSidePage] = useState<sidePages>({
      appliedworkers: true
   });




   useEffect(() => {
      getRequirementById(Token as string, id as string).then((res) => {

         // console.log(res?.data)
         if (res?.data?.status_code === 200) {
            setSelectedRequirement(res?.data?.data)
         }
      })

      // dispatch(startLoading())
   }, [id]);

   const dispatch = useAppDispatch();

   useEffect(() => {
      if (selectedRequirement?._id) {
         getAppliedWorkers(Token as string, selectedRequirement?._id as string, PaginatedData?.pageNo, PaginatedData?.pageSize).then((res) => {

            if (res?.data?.status_code === 200) {
               // console.log(res?.data?.data);
               setAppliedWorkers(res?.data?.data?.result);
               setPaginatedData({
                  ...PaginatedData,
                  totalPages: res?.data?.data?.totalPages
               });
               // totalAppliedWorkersCount = res?.data?.data?.totalPages;
               // setTotalPages(res?.data?.data?.totalPages);
               setTotalAppliedData({
                  ...totalAppliedData,
                  appliedCount: res?.data?.data?.totalDocs,
                  viewedCount: res?.data?.data?.viewsCount,
               });

               dispatch(stopLoading());
            } else {
               Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: `${res?.data?.data?.msg}`,
               });
            }
         });
      }

   }, [selectedRequirement, PaginatedData?.pageSize, PaginatedData?.pageNo])

   const istDate = moment(selectedRequirement?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');

   useEffect(() => {
      // console.log("PaginatedData: ", PaginatedData)
   }, [selectedRequirement?._id, PaginatedData?.pageSize, PaginatedData?.pageNo])



   const setHandlePageClick = (page: keyof sidePages) => {
      setClickedSidePage({
         appliedworkers: page === "appliedworkers"
      })
   }

   return (
      <MainLayout
         showAllFilters={true}
      >

         <div className="main-div">

            <div className={` category-main me-2 p-3 p-md-4 `} >
               {
                  loading ?
                     <div>
                        <LoadingGif />
                     </div>

                     : ""
               }

               <div className="row">
                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">
                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedRequirement?.icon
                                             ? typeof selectedRequirement?.icon === 'string'
                                                ? selectedRequirement?.icon
                                                : URL.createObjectURL(selectedRequirement?.icon)
                                             : iconPlaceholder
                                       }
                                    />
                                 </div>
                                 <div className="d-flex flex-column">

                                    {
                                       selectedOption === "Work" &&
                                       <h5 className="text-start mb-1">{selectedRequirement?.work_requirement ?? "NA"}</h5>

                                    }
                                    {selectedOption === "Job" &&
                                       <h5 className="text-start mb-1">{selectedRequirement?.hiring_type?.[0] ?? "NA"}</h5>
                                    }
                                    {selectedOption === "Material" &&
                                       <h5 className="text-start mb-1">{selectedRequirement?.material_requirement != null ? selectedRequirement?.material_requirement?.map((data) => {
                                          return data?.materialName
                                       })?.join(", ") : "NA"}</h5>
                                    }
                                    <span className="text-start mb-1">{selectedRequirement?.unique_id ?? "NA"}</span>
                                    <span className="text-start">Joined: {istDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Basic Information</h5>
                              <dl className="row mb-0">
                                 <dt className="col-4 fw-medium text-dark mb-3">ID</dt>
                                 <dd className="col-8 mb-3">{selectedRequirement?._id ?? "NA"}</dd>
                                 {selectedOption === "Material" &&
                                    <>
                                       <dt className="col-4 fw-medium text-dark mb-3">Brand Name</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.material_requirement != null ? selectedRequirement?.material_requirement?.map((data) => {
                                          return data?.brandName
                                       })?.join(", ") : "NA"}
                                       </dd>

                                       <dt className="col-4 fw-medium text-dark mb-3">Quantity</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.material_requirement != null ? selectedRequirement?.material_requirement?.map((data) => {
                                          return data?.qty
                                       })?.join(", ") : "NA"}
                                       </dd>

                                       <dt className="col-4 fw-medium text-dark mb-3">Quantity Type</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.material_requirement != null ? selectedRequirement?.material_requirement?.map((data) => {
                                          return data?.quantityType
                                       })?.join(", ") : "NA"}
                                       </dd>
                                    </>
                                 }
                                 {
                                    selectedOption !== "Job" && (
                                       <>
                                          <dt className="col-4 fw-medium text-dark mb-3">Estimated Budget</dt>
                                          <dd className="col-8 mb-3">{selectedRequirement?.estimated_budget ? selectedRequirement?.estimated_budget : "NA"}</dd>
                                       </>

                                    )
                                 }
                                 {
                                    selectedOption === "Job" && (
                                       <>
                                          <dt className="col-4 fw-medium text-dark mb-3">Hiring Type</dt>
                                          <dd className="col-8 mb-3">{selectedRequirement?.hiring_type?.[0] ? selectedRequirement?.hiring_type?.[0] : "NA"}</dd>

                                          <dt className="col-4 fw-medium text-dark mb-3">Hiring For</dt>
                                          <dd className="col-8 mb-3">{selectedRequirement?.hiring_for ? selectedRequirement?.hiring_for : "NA"}</dd>

                                          <dt className="col-4 fw-medium text-dark mb-3">Vacancy Count</dt>
                                          <dd className="col-8 mb-3">{selectedRequirement?.vacancy_count ? selectedRequirement?.vacancy_count : "NA"}</dd>

                                          <dt className="col-4 fw-medium text-dark mb-3">Salary Offered</dt>
                                          <dd className="col-8 mb-3">
                                             {selectedRequirement?.salary_offered?.length !== 0 ? selectedRequirement?.salary_offered : ""} 
                                          </dd>

                                          <dt className="col-4 fw-medium text-dark mb-3">Alternate Address</dt>
                                          <dd className="col-8 mb-3">{selectedRequirement?.alternate_address ? selectedRequirement?.alternate_address : "NA"}</dd>

                                       </>
                                    )
                                 }


                                 {selectedRequirement?.hiring_for === "company" && (
                                    <>
                                       <dt className="col-4 fw-medium text-dark mb-3">Firm Name</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.firm_name ? selectedRequirement?.firm_name : "NA"}</dd>
                                       <dt className="col-4 fw-medium text-dark mb-3">Firm Gst No.</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.gst_number ? selectedRequirement?.gst_number : "NA"}</dd>
                                    </>
                                 )}

                                 {selectedOption === "Work" &&
                                    <>
                                       <dt className="col-4 fw-medium text-dark mb-3">Approx Area</dt>
                                       <dd className="col-8 mb-3">{selectedRequirement?.approx_area ? selectedRequirement?.approx_area : "NA"}</dd>
                                    </>
                                 }

                                 <dt className="col-4 fw-medium text-dark mb-3">Description</dt>
                                 <dd className="col-8 mb-3">{selectedRequirement?.description ? selectedRequirement?.description : "NA"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3">Urgent Requirement</dt>
                                 <dd className="col-8 mb-3">{selectedRequirement?.urgent_looking ? selectedRequirement?.urgent_looking : "NA"}</dd>
                              </dl>

                           </div>
                        </div>

                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">Address</h5>
                           </div>

                           <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>
                                    <img src={currentAddress} alt="currentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Requirement Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedRequirement?.address.street || selectedRequirement?.address.pin_code || selectedRequirement?.address.city || selectedRequirement?.address.country ?
                                          `${selectedRequirement?.address.street ? (selectedRequirement?.address.street + ",") : ""} ${selectedRequirement?.address.pin_code || "NA"}, ${selectedRequirement?.address.city || "NA"}, ${selectedRequirement?.address.country || "NA"}`
                                          : "NA"
                                       }
                                    </p>
                                 </div>
                              </div>

                           </div>
                        </div>
                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">User Details</h5>
                           </div>

                           <div className="card-body">

                              <dl className="row mb-0">


                                 <dt className="col-4 fw-medium text-dark mb-3 text-start">Name</dt>
                                 <dd className="col-8 mb-3 text-start">{selectedRequirement?.user_name ? selectedRequirement?.user_name : "NA"}</dd>

                                 <dt className="col-4 fw-medium text-dark mb-3 text-start">Phone</dt>
                                 <dd className="col-8 mb-3 text-start">{selectedRequirement?.user_phone ? selectedRequirement?.user_phone : "NA"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3 text-start">Email</dt>
                                 <dd className="col-8 mb-3 text-start">{selectedRequirement?.user_email ? selectedRequirement?.user_email : "NA"}</dd>
                                 <dt className="col-4 fw-medium text-dark mb-3 text-start">Address</dt>
                                 <dd className="col-8 mb-3 text-start">  {selectedRequirement?.address.street || selectedRequirement?.address.pin_code || selectedRequirement?.address.city || selectedRequirement?.address.country ?
                                    `${selectedRequirement?.address.street ? (selectedRequirement?.address.street + ",") : ""} ${selectedRequirement?.address.pin_code || "NA"}, ${selectedRequirement?.address.city || "NA"}, ${selectedRequirement?.address.country || "NA"}`
                                    : "NA"
                                 }</dd>
                              </dl>


                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">

                     <div className="row ">

                        <div className="col-md-12">
                           <ul className="nav nav-tabs nav-tabs-bottom mb-4 border-bottom-0">
                              <li >
                                 <div className={` d-flex p-3 sidePages ${clickedSidePage?.appliedworkers ? "active" : ""}`}
                                    onClick={() => setHandlePageClick("appliedworkers")}>
                                    <span className="d-flex justify-content-center align-items-center me-2" >
                                       <svg fill={clickedSidePage?.appliedworkers ? "#3D5EE1" : "#000000"} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: "13px", height: "13px" }}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M15 11h7v2h-7zm1 4h6v2h-6zm-2-8h8v2h-8zM4 19h10v-1c0-2.757-2.243-5-5-5H7c-2.757 0-5 2.243-5 5v1h2zm4-7c1.995 0 3.5-1.505 3.5-3.5S9.995 5 8 5 4.5 6.505 4.5 8.5 6.005 12 8 12z"></path></g></svg>

                                    </span>
                                    <button className="border-0 bg-transparent">
                                       Applied Workers
                                    </button>
                                 </div>
                              </li>

                           </ul>
                           {
                              clickedSidePage?.appliedworkers ?
                                 <div className="card">
                                    <div className="card-header d-flex justify-content-between" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                       <h5 className="text-start mb-0" >
                                          {selectedOption === "Material" ? "Seller" : "Worker"} Profiles
                                       </h5>
                                       <div>
                                          <div className="d-flex gap-3" style={{ fontWeight: "500", fontSize: "15px" }}>
                                             <span className="d-flex align-items-center" >Total Applied workers:</span>
                                             <span className="d-flex align-items-center">{totalAppliedData?.appliedCount ?? 0}</span>
                                          </div>

                                       </div>

                                    </div>
                                    <div className="card-body">
                                       <div className="border rounded p-3 pb-0 transaction-body" >
                                          <div className="table-responsive">
                                             <table className="table  card-body">
                                                <thead>
                                                   <tr className="transaction-tr">
                                                      <th scope="col" className="text-start ps-4">sr.No</th>
                                                      <th scope="col" className="text-start ps-4">Profile Pic</th>
                                                      <th scope="col" className="text-start ps-4">Name</th>
                                                      <th scope="col" className="text-start ps-4">Worker Type</th>
                                                      <th scope="col-3" className="text-start ps-4">Specifications</th>
                                                      <th scope="col" className="text-start ps-4">Phone No.</th>
                                                      <th scope="col" className="text-start ps-4">Is Verified</th>
                                                      <th scope="col" className="text-start ps-4">Average Rating</th>
                                                      <th scope="col" className="text-start ps-4">Applied At</th>
                                                      <th scope="col" className="text-start ps-4">Action</th>

                                                   </tr>
                                                </thead>
                                                <tbody>
                                                   {
                                                      appliedWorkers && appliedWorkers?.map((data, i) => {
                                                         const createdAt = moment(data?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY');
                                                         const rowNumber = (PaginatedData?.pageNo - 1) * PaginatedData?.pageSize + (i + 1);

                                                         return (
                                                            <tr key={data?._id}>


                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {rowNumber}
                                                                  </span>
                                                               </td>
                                                               <td className="text-start align-content-center">
                                                                  {data?.profile_pic ?
                                                                     <img src={data?.profile_pic as string} alt="profile-pic" className="profile-pic" />
                                                                     :
                                                                     <span className="d-flex align-items-center ">
                                                                        <img src={profileIcon} alt="profileIcon" className="profile-pic" />
                                                                     </span>}
                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {data?.worker_name}
                                                                  </span>

                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {formatCategory(data?.worker_type)}
                                                                  </span>

                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">

                                                                     {getSpecializations(data)}

                                                                  </span>

                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {data?.phone}
                                                                  </span>
                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  <span className="">
                                                                     {data?.is_verified ? "Yes" : "No"}
                                                                  </span>
                                                               </td>
                                                               <td className="text-start align-content-center ps-4">
                                                                  {
                                                                     data?.average_ratings >= 1 ?
                                                                        <StarRating averageRating={data?.average_ratings || 0} />
                                                                        : "No Ratings"
                                                                  }

                                                                  {/* <StarRating averageRating={3.6} /> */}

                                                               </td>


                                                               <td className="text-start align-content-center ps-4 ">
                                                                  <span className=" align-items-center">
                                                                     {createdAt}
                                                                  </span>
                                                               </td>
                                                               <td className="align-content-center ">
                                                                  <div className="d-flex justify-content-center gap-3 ">
                                                                     <Link to={`/workers/${data?.worker_id}`}>
                                                                        <button className="btn btn-sm delete_btn" >
                                                                           <img src={eye} />
                                                                        </button>
                                                                     </Link>
                                                                  </div>
                                                               </td>
                                                            </tr>
                                                         )
                                                      }
                                                      )
                                                   }

                                                </tbody>
                                             </table>
                                          </div>

                                       </div>
                                       <div className="mt-3">
                                          <Paginator

                                             totalPages={PaginatedData?.totalPages}
                                             pageNo={PaginatedData?.pageNo}
                                             onPageChange={(e, no) => setPaginatedData({
                                                ...PaginatedData,
                                                pageNo: no

                                             })}
                                             alignment="right"
                                          />
                                       </div>

                                    </div>
                                 </div> : ''
                           }

                        </div>
                     </div>
                  </div>

               </div>

            </div>

         </div>

      </MainLayout>
   )



};



export default RequirementDetailsPage;